var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgBookmark = function SvgBookmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 25",
    className: "bookmark_svg__svg-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 7.992a5 5 0 0 1 5-5h6a5 5 0 0 1 5 5V19.98c0 2.554-2.987 3.94-4.937 2.29l-2.417-2.043a1 1 0 0 0-1.292 0l-2.417 2.044C6.987 23.92 4 22.535 4 19.982V7.991zm5-3a3 3 0 0 0-3 3v11.99a1 1 0 0 0 1.646.763l2.417-2.044a3 3 0 0 1 3.874 0l2.417 2.044A1 1 0 0 0 18 19.98V7.991a3 3 0 0 0-3-3H9z",
    fill: "currentColor"
  })));
};

export { SvgBookmark as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNSIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTQgNy45OTJhNSA1IDAgMDE1LTVoNmE1IDUgMCAwMTUgNVYxOS45OGMwIDIuNTU0LTIuOTg3IDMuOTQtNC45MzcgMi4yOWwtMi40MTctMi4wNDNhMSAxIDAgMDAtMS4yOTIgMGwtMi40MTcgMi4wNDRDNi45ODcgMjMuOTIgNCAyMi41MzUgNCAxOS45ODJWNy45OTF6bTUtM2EzIDMgMCAwMC0zIDN2MTEuOTlhMSAxIDAgMDAxLjY0Ni43NjNsMi40MTctMi4wNDRhMyAzIDAgMDEzLjg3NCAwbDIuNDE3IDIuMDQ0QTEgMSAwIDAwMTggMTkuOThWNy45OTFhMyAzIDAgMDAtMy0zSDl6IiBmaWxsPSJjdXJyZW50Q29sb3IiLz48L3N2Zz4=";